import { clearLegacyAuthStorage } from "@/utils/authStorage";

export const AUTH_BASE_URL = `${process.env.VUE_APP_API_BASE_URL}/api/auth`;
export const AUTH_LOGIN_URL = `${AUTH_BASE_URL}/login`;
export const AUTH_REFRESH_URL = `${AUTH_BASE_URL}/refresh`;

let loginRedirectInProgress = false;

export function isUnauthorizedError(error) {
  return error?.response?.status === 401;
}

// For a failed refresh: the API answers 400 (no refresh cookie) or 403 (bad
// signature or ended session) when there is no session left, never 401.
export function isSessionEndedError(error) {
  return [400, 401, 403].includes(error?.response?.status);
}

export function isAuthRefreshRequest(config = {}) {
  return config.url === AUTH_REFRESH_URL;
}

export function shouldAttemptAuthRefresh(config = {}) {
  if (!config || config._retry || config.skipAuthRefresh) return false;

  const method = (config.method || "get").toLowerCase();
  const url = config.url || "";

  if (url === AUTH_REFRESH_URL || url === AUTH_LOGIN_URL) return false;

  // POST /api/auth is logout; retrying it via refresh can clear a valid session.
  if (url === AUTH_BASE_URL && method === "post") return false;

  return true;
}

export function redirectToGatewayLogin() {
  clearLegacyAuthStorage();

  if (loginRedirectInProgress || typeof window === "undefined") return;

  loginRedirectInProgress = true;
  window.location.href =
    `${process.env.VUE_APP_GATEWAY_PORTAL_BASE_URL}/login?redirect=` +
    window.location.origin +
    "/login";
}

export function resetLoginRedirectForTests() {
  loginRedirectInProgress = false;
}
